import { zodResolver } from '@hookform/resolvers/zod';
import { Resolver } from 'react-hook-form';

import { FormValues } from './FormValues';
import { schema } from './schema';

// TODO: There are a couple of zod resolvers left in the codebase that should be
// removed. Casting until we do that.
export const resolver: Resolver<FormValues> = zodResolver(
  schema
) as Resolver<FormValues>;
